import { DataGridProProps, GridValidRowModel } from '@mui/x-data-grid-pro';

import { LineItemSourcingCaseAssignments } from '../../ContractDemandAwardingWidget.hooks';
import { ContractDemand, ContractDemandSourcingCase } from '../../ContractDemandAwardingWidget.types';
import { TsrctAwardingStatusEntityVariant, TsrctAwardingStatusField, TsrctStatus } from '@/generated/gql/graphql.ts';

export interface UseAwardingDataGridProps {
  contractDemand: ContractDemand;
  lineItemAssignments: LineItemSourcingCaseAssignments;
}
export interface AwardingDataGridRow {
  id: string;
  type: AwardingDataGridRowType;
  renderLabelCell?: () => React.ReactNode;
  renderContentCell?: (sourcingCase: ContractDemandSourcingCase) => React.ReactNode;
  getContentCellClassName?: (sourcingCase: ContractDemandSourcingCase) => string;
}

export type UseAwardingDataGridConfig<R extends GridValidRowModel = any> = (
  props: UseAwardingDataGridProps,
) => Pick<
  DataGridProProps<R>,
  | 'rows'
  | 'columns'
  | 'pinnedRows'
  | 'initialState'
  | 'groupingColDef'
  | 'getTreeDataPath'
  | 'isRowSelectable'
  | 'columnHeaderHeight'
>;

export enum AwardingDataGridField {
  ID = 'id',
  PRIORITY = 'priority',
}

export enum AwardingDataGridGroupType {
  STATUS = 'grpStatus',
  QUOTE = 'grpQuote',
  LINE_ITEMS = 'grpLineItems',
  SUPPLIER = 'grpSupplier',
}

export type AwardingDataGridGroup = `${AwardingDataGridGroupType}`;

export enum AwardingDataGridRowType {
  STATUS_HEADLINE = 'statusHeadline',
  PROCESSED_BY = 'processedBy',
  STATUS = 'status',
  CONTRACTS = 'contracts',

  CONTRACT_HEADLINE = 'contractHeadline',
  VALIDITY_PERIOD = 'validityPeriod',
  INITIAL_TOTAL = 'initialTotal',
  DISCOUNT = 'discount',
  FINAL_TOTAL = 'finalTotal',

  AWARDING_HEADLINE = 'awardingHeadline',
  LINE_ITEM = 'lineItem',
  AWARD_ALL_ITEMS = 'awardAllItems',
  QUANTITY = 'quantity',
  PRICE_PER_PRICE_UNIT = 'pricePerPriceUnit',
  TOTAL_VALUE = 'totalValue',
}

export type EntityStatusGetter = (args: {
  entityVariant: TsrctAwardingStatusEntityVariant;
  field: TsrctAwardingStatusField;
  entityId: string;
}) => TsrctStatus;
